// extracted by mini-css-extract-plugin
export default {"aboutContainer":"aboutUs_aboutContainer__oPsH2","txt":"aboutUs_txt__46O64"};